<template>
  <div class="relation">
    <template
      v-if="
        contractStatus != 'ZT07' &&
        contractStatus != 'ZT023' &&
        contractStatus != 'ZT02' &&
        contractStatus != 'ZT021'
      "
    >
      <SelectTableDialog
        :title="$t('salePurchase.other.relative')"
        :searchColumns="searchColumns"
        :columnList="searchList"
        :API="API"
        :extraData="getExtraData"
        width="1200px"
        ref="relationInfo"
        @confirm="confirm"
        :confirmUnchecked="false"
        propCode="contractNo"
        :checkRowKeys="checkRowKeys"
      >
        <el-button size="small" type="primary" class="vxe-btn-primary">关联合同</el-button>
      </SelectTableDialog>

      <el-button
        size="small"
        type="danger"
        class="vxe-btn-delete"
        @click="deleteEvent()"
        style="margin-left: 10px"
        >删除</el-button
      >
    </template>

    <vxe-table
      border
      show-overflow
      resizable
      :auto-resize="true"
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      :data="tableData"
      @cell-dblclick="dblclickEvent"
      :checkbox-config="{ checkMethod: checkMethod }"
      :edit-config="editConfig"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" width="80" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :type="item.type"
        :key="index"
        :fixed="item.fixed"
        :field="item.prop"
        :title="item.label"
        :width="item.width"
        :sortable="item.sortable"
        :edit-render="item.editRender"
      >
        <template v-slot:edit="{ row }">
          <el-select
            v-model="row[item.prop]"
            @change="(val) => change(val, row)"
            clearable
            filterable
            :disabled="
              row.relatedMethod == '2' || contractStatus == 'ZT02' || contractStatus == 'ZT03'
            "
          >
            <el-option
              v-for="key in item.options"
              :key="key.value"
              :label="key.label"
              :value="key.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="scope">
          <template v-if="item.editRender">{{ scope.row.relationShipIdentityName }}</template>
          <template v-else>{{ scope.row[item.prop] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import API from '@/api/purchaseSalesCenter/purchaseSales.js';

  export default {
    name: 'relation',
    components: {
      SelectTableDialog,
    },
    props: {
      defaultData: {
        type: Array,
        default: () => [],
      },
      contractNo: {
        type: String,
        default: '',
      },
      isEdit: {
        type: Boolean,
        default: () => false,
      },
      contractStatus: {
        type: String,
        default: '',
      },
    },
    watch: {
      // 将默认值给表格数据
      defaultData() {
        this.checkRowKeys = this.defaultData.map((item) => {
          return item.relatedContractNo;
        });
        this.tableData = this.defaultData.slice();
      },
      isEdit(newValue) {
        this.edit = newValue;
        this.editConfig = newValue ? {} : { trigger: 'click', mode: 'row' };
      },
    },
    data() {
      return {
        API: API.GET_LIST_API,
        tableData: [],
        checkRowKeys: [],
        extraData: {},
        //修改时记录删除行项目的id
        relationshipDelIds: [],
        editConfig: {},
      };
    },
    computed: {
      getExtraData() {
        let extraData = {
          relationContractCategory:
            this.$route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
          relationContractDetailCategory: this.$route.query.type,
          contractStatus: 'ZT03',
        };

        if (['物贸', '国贸'].includes(this.userInfo.businessGroup)) {
          extraData = {
            relationContractCategory:
              this.$route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
            relationContractDetailCategory: this.$route.query.type,
            listStatus: [
              'ZT06',
              'ZT00',
              'ZT03',
              'ZT05',
              'ZT02',
              'ZT022',
              'ZT061',
              'ZT021',
              'ZT051',
            ],
          };
        }
        return extraData;
      },
      searchColumns() {
        return [
          {
            prop: 'contractNo',
            name: this.$t('salePurchase.search.contractNo'),
            type: 'input',
            maxlength: 50,
            placeholder: this.$t('salePurchase.search.contractNoPlaceholder'),
          },
        ];
      },
      // 表格展示数据
      columnList() {
        return [
          {
            prop: 'relatedContractNo',
            label: this.$t('contractAgency.relationTab.number'),
          },
          {
            prop: 'relatedContractTypeName',
            label: this.$t('contractAgency.relationTab.type'),
          },
          {
            prop: 'relatedContractCreateDate',
            label: this.$t('contractAgency.relationTab.createTime'),
          },
          {
            prop: 'relationShipIdentity',
            label: this.$t('contractAgency.relationTab.identify'),
            editRender: {
              name: 'ElSelect',
              type: 'default',
            },
            options: [
              { value: '0', label: this.$t('contractAgency.relationTab.before') },
              { value: '1', label: this.$t('contractAgency.relationTab.after') },
            ],
          },
        ];
      },
      // 搜索表格列表
      searchList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('contractAgency.relationTab.number'),
          },
          {
            prop: 'contractDetailCategoryName',
            label: this.$t('contractAgency.relationTab.type'),
          },
          {
            prop: 'contractCreateDate',
            label: this.$t('contractAgency.relationTab.createTime'),
          },
        ];
      },
    },
    mounted() {
      console.log(this.contractStatus, '合同状态relationinfo');
    },
    created() {
      this.editConfig = this.isEdit ? {} : { trigger: 'click', mode: 'row', showStatus: true };
    },
    methods: {
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.xTable;
        return $table.getTableData().fullData;
      },
      //关联标识
      change(val, row) {
        if (val) {
          row.relationShipIdentityName =
            val == '0'
              ? this.$t('contractAgency.relationTab.before')
              : this.$t('contractAgency.relationTab.after');
        } else {
          row.relationShipIdentityName = '';
        }
      },
      confirm(multipleSelection) {
        let list = this.$refs.xTable.getTableData().fullData;
        multipleSelection.forEach((item) => {
          let flag = true;
          for (let i = 0; i < list.length; i++) {
            if (list[i].relatedContractNo == item.contractNo) {
              flag = false;
            }
          }
          if (flag) {
            // 给需要的值给表格展示
            list.push({
              relatedContractNo: item.contractNo,
              relatedContractType: item.contractDetailCategory,
              relatedContractTypeName: item.contractDetailCategoryName,
              relatedContractCreateDate: item.contractCreateDate,
              relationshipType: item.contractCategory,
              relationShipIdentity: item.relationShipIdentity,
              relationShipIdentityName: item.relationShipIdentityName,
            });
          }
        });
        this.tableData = this.filterArr(list.slice(), 'relatedContractNo');
        // 关闭弹窗
        this.$refs.relationInfo.dialogVisible = false;
      },
      //剔除同数据
      filterArr(arr, name) {
        let hash = {};
        return arr.reduce((ss, item) => {
          // reduce累计器, ss是具体满足条件后返回的数据, item是数组依次循环的每一项
          hash[item[name]] ? '' : (hash[item[name]] = true && ss.push(item));
          // 1、判断对象的键值是否存在
          return ss;
        }, []);
      },
      //自动关联的不允许删除
      checkMethod({ row }) {
        if (row.relatedMethod == '2') {
          return false;
        }
        return true;
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$confirmAction(this.$t('confirm.content'), '')
            .then(() => {
              //删除时记录删除明细id
              selectRecords.map((item) => {
                if (item.id) {
                  this.relationshipDelIds.push(item.id);
                }
              });
              this.$refs.xTable.removeSelecteds();
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('cooperation.message.cancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      dblclickEvent(val) {
        if (val.column.property == 'relationShipIdentity') {
          return;
        }
        const row = val.row;
        let pathName = '';
        let title = '';
        let url = '';
        //年度采购协议
        if (row.relatedContractType == 'HT01') {
          pathName = 'yearPurchaseEdit';
          title = '年度采购协议修改';
          url = '/salePurchase/yearPurchaseEdit';
        }
        //月度采购协议
        if (row.relatedContractType == 'HT02') {
          pathName = 'monthPurchaseEdit';
          title = '月度采购协议修改';
          url = '/salePurchase/monthPurchaseEdit';
        }
        //单次采购合同
        if (row.relatedContractType == 'HT03') {
          pathName = 'singlePurchaseContractEdit';
          title = '单次采购合同修改';
          url = '/salePurchase/singlePurchaseContractEdit';
        }
        //采购意向单
        if (row.relatedContractType == 'HT04') {
          pathName = 'purchaseIntentEdit';
          title = '采购意向单修改';
          url = '/salePurchase/purchaseIntentEdit';
        }
        //年度销售协议
        if (row.relatedContractType == 'HT05') {
          pathName = 'yearSaleEdit';
          title = '年度销售协议修改';
          url = '/salePurchase/yearSaleEdit';
        }
        //月度销售协议
        if (row.relatedContractType == 'HT06') {
          pathName = 'monthSaleEdit';
          title = '月度销售协议修改';
          url = '/salePurchase/monthSaleEdit';
        }
        //单次销售合同
        if (row.relatedContractType == 'HT07') {
          pathName = 'singleSaleEdit';
          title = '单次销售合同修改';
          url = '/salePurchase/singleSaleEdit';
        }
        //销售意向单
        if (row.relatedContractType == 'HT08') {
          pathName = 'saleIntentEdit';
          title = '销售意向单修改';
          url = '/salePurchase/saleIntentEdit';
        }
        //代理合同
        if (row.relatedContractType == 'HT09') {
          pathName = 'agencyContractEdit';
          title = '代理合同';
          url = '/agencyContract/edit';
        }
        let path = {
          path: url,
          name: pathName,
          meta: {
            keepAlive: false,
            title: title,
          },
          query: {
            type: row.relatedContractType,
            contractNo: row.relatedContractNo,
            contractStatus: 'ZT03',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 获取关联明细
      getValues() {
        return this.tableData.map((item) => {
          const result = Object.assign({}, item);
          if (this.contractNo) {
            result.contractNo = this.contractNo;
          }
          return result;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .vxe-table-element {
    margin-top: 5px;
  }

  .relation {
    margin-bottom: 10px;
  }
</style>
